<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

// vuex state.dialog 를 computed로 매핑
const isVisible     = computed(() => store.state.dialog.isVisible);
const title         = computed(() => store.state.dialog.title);
const content       = computed(() => store.state.dialog.content);
const dialogType    = computed(() => store.state.dialog.type);
const size          = computed(() => store.state.dialog.size);
const confirmText   = computed(() => store.state.dialog.confirmText);
const confirmColor  = computed(() => store.state.dialog.confirmColor);
const cancelText    = computed(() => store.state.dialog.cancelText);

// vuex action 호출
const closeDialog   = () => store.dispatch('closeDialog');
const confirmDialog = () => store.dispatch('confirmDialog');
const cancelDialog  = () => store.dispatch('cancelDialog');

// alert 일 때 small 클래스 반영
const dialogClass = computed(() => {
  let classes = [];
  if (size.value === '') {
    if (dialogType.value === 'alert') {
      classes.push('small');
    }
  } else {
    classes.push(size.value);
  }
  return classes.join(' ');
});
</script>

<template>
  <Dialog
    v-model:visible="isVisible"
    modal
    :showHeader="title !== ''"
    :closable="false"
    :class="dialogClass"
  >
    <template #header>
      <span class="p-dialog-title" data-pc-section="headertitle">{{ title }}</span>
      <div class="spacer"></div>
      <Button text rounded class="icon secondary" @click="closeDialog">
        <i class="pi pi-times"></i>
      </Button>
    </template>
    <div v-html="content" :class="{'pt-20' : title == ''}"></div>
    <template #footer>
        <Button class="secondary" text @click="cancelDialog">
          <span>{{ dialogType === 'alert' && cancelText === '취소' ? '확인' : cancelText }}</span>
        </Button>
        <Button v-if="dialogType === 'confirm'" :class="confirmColor" text @click="confirmDialog">
          <span>{{ confirmText }}</span>
        </Button>
    </template>
  </Dialog>
</template>